import { useSyncExternalStore } from 'react';
import { SpeakerWithDetails } from '@/context/TranscriptContext/TranscriptContextTypes';
import createStore from '@/stores/store';

type SpeakerDetailStoreType = Record<string, Record<string, SpeakerWithDetails>>;

export const speakerDetailsStore = createStore<SpeakerDetailStoreType>({});

export const updateSpeakerDetailsStoreForBroadcast = (
  broadcastId: string,
  speakerDetails: Record<string, SpeakerWithDetails>
) => {
  speakerDetailsStore.update(prev => {
    const newState = { ...prev };
    newState[broadcastId] = speakerDetails;
    return newState;
  });
};

const emptyObject = {};

export const getSpeakerDetailsForBroadcast = (broadcastId: string, snapshot?: SpeakerDetailStoreType) => {
  const snap = snapshot ?? speakerDetailsStore.getSnapshot();
  return snap[broadcastId] ?? emptyObject;
};

export const useSpeakerDetailsForBroadcast = (broadcastId: string) => {
  const speakerDetailsStoreSnapshot = useSyncExternalStore(
    speakerDetailsStore.subscribe,
    speakerDetailsStore.getSnapshot
  );
  return getSpeakerDetailsForBroadcast(broadcastId, speakerDetailsStoreSnapshot);
};
